export default __webpack_public_path__ + "static/media/partner (11).a8890d7d.png";